import React, { useState } from "react";
import QuantmanWelcome from "./QuantmanWelcome/QuantmanWelcome";
import ReasonsChoose from "./ReasonsChoose/ReasonsChoose";
import Howtostart from "./howtostart/HowtoQuantman";
import QuantmanDownload from "./QuantmanDownload/QuantmanDownload" 
import { Image } from "react-bootstrap/Image";
import CallTrackApi from "../Activity_Track/CallTrackApi";
function Quantman() {
  window.scrollTo(0, 0)
  const [welcomeData, setWelcomeSection] = useState(
    {
      title: "BackTest Your Strategies With Quantman",
    },
    []
  );
  CallTrackApi("Quantman",window.location.href);
  return (
    <>
      <QuantmanWelcome data={welcomeData} />
          <ReasonsChoose />
          <Howtostart />
          <QuantmanDownload />
          
    </>
  );
}
export default Quantman;

